import cn from "classnames";
import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import Loader from "../../components/Loader";

import { UseApi } from "../../hooks/use-api";
import {
	GetBrandBalance,
	GetBrandBalanceHistory,
	GetBrandStripeSecrets,
	PostBrandReFund,
	PostBrandStripeCredentials,
} from "../../Services/lib/brand";
import styles from "./Monetize.module.sass";
import { useUser } from "../../context";
import finance from "../../i11/Finance";
import Row from "./row";
import Sybmols from "./Currencies.json";

import Modal from "../../components/Modal";
import TextInput from "../../components/TextInput";
import Dropdown from "../../components/Dropdown";
import HeaderBalance from "./HeaderBalance";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const LIMIT = 8;

const Monetize = () => {
	const { locale } = useUser();
	const reFundOptions = [
		finance[locale].duplicate,
		finance[locale].fraudulent,
		finance[locale].requested_by_customer,
		finance[locale].other,
	];

	const [hintText, setHintText] = useState("");
	const [description, setDescription] = useState("");
	const [ticketNumber, setTicketNumber] = useState("");
	// refund
	const [refundVisible, setReFund] = useState(false);
	const [amount, setAmount] = useState("");
	const [selected, setSelected] = useState(finance[locale].select_a_reason);
	const [note, setNote] = useState("");
	const [charge_id, setCharge_id] = useState("");

	// stripe
	const [publicKeyV, setPublicKeyV] = useState("");
	const [privateSecterV, setPrivateSecterV] = useState("");

	const [{ data: balance, isLoading: balanceIsLoading }, getBalance] = UseApi(
		{
			service: GetBrandBalance,
		}
	);

	const [last, setLast] = useState();
	const [hasNext, setHasNext] = useState(true);
	const [history, setHistory] = useState([]);

	const [{ isLoading }, getBalanceList] = UseApi({
		service: GetBrandBalanceHistory,
	});

	const getBalanceList_ = async () => {
		const param = {
			limit: LIMIT,
		};

		if (last) {
			param.starting_after = last;
		}
		if (hasNext) {
			const res = await getBalanceList(param);
			if (res && res.data && res.data !== null) {
				if (res.data?.length > 0) {
					setLast(res.data[res.data.length - 1].id);
				}
				setHistory((p) => [...p, ...res.data]);

				setHasNext(res.has_more);
			}
		}
	};

	// get stripe [ check ]
	const [
		{ data: stripe, error: errorSecrets, isLoading: loadingStripe },
		getSecrets,
	] = UseApi({
		service: GetBrandStripeSecrets,
	});
	// post Stripe
	const [{ data: stripeData, isLoading: stripeLoading }, postStripe] = UseApi(
		{
			service: PostBrandStripeCredentials,
			successMsg: "Success",
		}
	);

	const saveStripeAccounts = async () => {
		const res = await postStripe({
			secretKey: privateSecterV,
			publicKey: publicKeyV,
		});
		if (res) {
			getSecrets();
			setPublicKeyV("");
			setPublicKeyV("");
		}
	};

	// reFund func
	const [{ data: reFundData, isLoading: reFundLoading }, postReFund] = UseApi(
		{
			service: PostBrandReFund,
			successMsg: "You have successfully connect your account.",
		}
	);
	const refund = async () => {
		let reason = selected.toLowerCase().replaceAll(" ", "_");

		let dataBody = {
			charge_id: charge_id,
			amount: amount,
			reason,
			description,
			ticket_number: ticketNumber,
		};

		if (reason === "other") {
			delete dataBody.reason;
		}
		const result = await postReFund(dataBody);
		if (result) {
			let items = [...history];
			const newState = items.map((obj) => {
				// 👇️this is static
				if (obj.id === charge_id) {
					console.log(amount);
					console.log(amount * 100 === obj.amount);
					return {
						...obj,
						amount_refunded: amount * 100,
						amount_captured: 9999999,
						captured: true,
						refunded: amount * 100 === obj.amount,
					};
				}
				return obj;
			});
			setHistory(newState);
			setReFund(false);
			setCharge_id("");
			setAmount("");
			setSelected("");
		}
	};

	const selectDropdown = (val) => {
		switch (val) {
			case finance[locale].duplicate:
				setHintText(finance[locale].duplicate_d);
				break;
			case finance[locale].fraudulent:
				setHintText(finance[locale].fraudulent_d);
				break;
			case finance[locale].requested_by_customer:
				setHintText(finance[locale].requested_by_customer_d);
				break;
			case finance[locale].other:
				setHintText(finance[locale].other_d);
				break;
		}
		setNote(finance[locale].other === val ? finance[locale].node_d : "");
		setSelected(val);
	};

	useEffect(() => {
		getBalance();
		getBalanceList_();
		getSecrets();
	}, []);
	return (
		<Card>
			<div className={cn("title-green", styles.title)}>
				{finance[locale].balance}
			</div>

			{balanceIsLoading ? (
				<div className={styles.loaderWrap}>
					<Loader />
				</div>
			) : (
				<>
					<HeaderBalance className={styles.card} balance={balance} />
				</>
			)}

			<>
				<div className={cn("title-green", styles.title)}>
					{finance[locale].stripe_integrate}
				</div>
				{loadingStripe ? (
					<Loader />
				) : (
					<div className={styles.buttonCnnt}>
						<div className={styles.btncont}>
							{stripe?.secretKey ? (
								<p>{finance[locale].connect_disclaimer}</p>
							) : (
								<p>{finance[locale].disclaimer}</p>
							)}

							<div className={styles.rowF}>
								<a
									href="https://dashboard.stripe.com"
									target="_blank"
									className="button-small"
									rel="noreferrer"
								>
									{finance[locale].go_to_stripe}
								</a>

								{stripe?.secretKey ? (
									<div>{stripe?.secretKey}</div>
								) : (
									<div>
										<div className={styles.textField}>
											<p>{finance[locale].public_key}</p>
											<TextInput
												type="text"
												className={styles.textWidth}
												onChangeInput={(e) =>
													setPublicKeyV(e)
												}
											/>
										</div>

										<div className={styles.textField}>
											<p>{finance[locale].secret_key}</p>
											<TextInput
												className={styles.textWidth}
												onChangeInput={(e) =>
													setPrivateSecterV(e)
												}
												type="text"
											/>
										</div>

										<button
											className={`button-small ${styles.end}`}
											rel="noreferrer"
											onClick={saveStripeAccounts}
										>
											{stripeLoading && <Loader />}{" "}
											Connect
										</button>
									</div>
								)}
							</div>
						</div>
					</div>
				)}
			</>
			<div className={cn("title-blue", styles.title)}>
				{finance[locale].history}
			</div>
			<div className={cn(styles.wrapper)}>
				<div className={cn(styles.table)}>
					<div className={styles.row}>
						<div className={styles.col} />
						<div className={styles.col}>
							{finance[locale].amount}
						</div>
						<div className={styles.col}>{""}</div>
						<div className={styles.col}>
							{finance[locale].status}
						</div>
						<div className={styles.col}>
							{finance[locale].destination}
						</div>
						<div className={styles.col}>
							{finance[locale].transaction_ID}
						</div>
						<div className={styles.col}>{finance[locale].date}</div>
						<div className={styles.col}>{"..."}</div>
					</div>
					{history.map((e) => {
						return (
							<Row
								data={e}
								key={e.id}
								clickRefund={(e) => {
									if (e.captured != true) return;
									setCharge_id(e.id);
									setAmount(e.amount / 100);
									setReFund(true);
								}}
							/>
						);
					})}
				</div>
				<div className={styles.foot}>
					{hasNext && (
						<button
							onClick={getBalanceList_}
							className={cn("button", { disabled: isLoading })}
						>
							{isLoading && <Loader />}
							{finance[locale].show_more}
						</button>
					)}
				</div>
			</div>

			{/* Refund Payment dialog */}
			<Modal visible={refundVisible} onClose={() => setReFund(false)}>
				<div className={cn("title-yellow", styles.title)}>
					{finance[locale].refund_payment}
				</div>
				{
					<div className={styles.note}>
						{finance[locale].refund_dialog_desc}
						<br />
						<a
							href="https://support.stripe.com/questions/understanding-fees-for-refunded-payments/"
							target="_blank"
							rel="noreferrer"
						>
							{finance[locale].lean_more}
						</a>
					</div>
				}
				<p>{finance[locale].amount}</p>
				<TextInput
					type={"number"}
					placeholder="0.0 $"
					value={amount}
					onChangeInput={(e) => setAmount(e)}
				/>
				<div className={styles.spacer20}></div>

				<p>{finance[locale].reason}</p>
				<Dropdown
					value={selected}
					setValue={(e) => {
						selectDropdown(e);
					}}
					options={reFundOptions}
				/>
				<div className={styles.spacer20}></div>
				{hintText !== "" && (
					<textarea
						className={cn(styles.textarea, styles.input)}
						placeholder={hintText}
						onChange={(e) => {
							setDescription(e.target.value);
						}}
					/>
				)}
				<p className={styles.smalltext}>{note}</p>
				<div className={styles.spacer20}></div>

				<p>{finance[locale].ticket_number}</p>
				<TextInput
					// placeholder="Ticket number"
					onChangeInput={(e) => setTicketNumber(e)}
				/>

				<div className={styles.spacer20}></div>
				<div className={styles.foot}>
					<button className="button" onClick={refund}>
						{reFundLoading && <Loader />}
						{finance[locale].refund}
					</button>
				</div>
			</Modal>
		</Card>
	);
};

export default Monetize;
